<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Mural de avisos
        </h6>
      </template>
      <b-card-text>
        <b-table
          :busy="isBusy"
          :fields="fields"
          hover
          no-border-collapse
          :items="items"
          small
          show-empty
          stacked="md"
          @row-clicked="verAvisoLinha"
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(icon)="row">
            <div class="actions-icons">
              <div class="wrapper-icon">
                <font-awesome-icon
                  :icon="
                    row.item.DATA_VISUALIZACAO != null
                      ? 'envelope-open-text'
                      : 'envelope'
                  "
                  class="mx-2"
                />
              </div>
            </div>
          </template>
          <template v-slot:cell(DataCadastro)="row">
            <div>
              <span
                :class="
                  row.item.DATA_VISUALIZACAO != null ? '' : 'font-weight-bold'
                "
                >{{ row.item.DataCadastro.toLocaleDateString() }}</span
              >
            </div>
          </template>
          <template v-slot:cell(Titulo)="row">
            <div>
              <span
                :class="
                  row.item.DATA_VISUALIZACAO != null ? '' : 'font-weight-bold'
                "
                >{{ row.item.Titulo }}</span
              >
            </div>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-aviso"
      size="xl"
      button-size="sm"
      centered
      header-bg-variant="secondary"
      header-text-variant="light"
      header-class=""
      footer-class=""
      modal-class="p-2"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header="">
        <h5>{{ avisoSelecionado.Titulo }}</h5>
      </template>
      <div id="messageContent" v-if="avisoSelecionado">
        <span v-html="avisoSelecionado.Mensagem" />
        <div class="mt-2 w-100" v-if="anexosAviso.length > 0">
          <h6>Anexos</h6>
          <ul class="listaAnexos">
            <li v-for="arquivo in anexosAviso" :key="arquivo.Nome">
              <div>
                {{ arquivo.Nome }}
                <btn-download
                  class="ml-2"
                  :texto="''"
                  :fazerDownload="downloadArquivo"
                  :parametros="arquivo"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <br />
      <b-card v-if="avisoSelecionado && avisoSelecionado.PermiteResposta">
        <div class="mb-2">
          <span><strong>Resposta</strong></span>
        </div>
        <div v-if="respostaSelecionada">
          <span v-html="respostaSelecionada.Mensagem" />
          <div
            class="mt-2 w-100"
            v-if="respostaSelecionada.Arquivos.length > 0"
          >
            <h6>Anexos</h6>
            <ul class="listaAnexos">
              <li
                v-for="arquivo in respostaSelecionada.Arquivos"
                :key="arquivo.Nome"
              >
                <div>
                  {{ arquivo.Nome }}
                  <btn-download
                    class="ml-2"
                    :texto="''"
                    :fazerDownload="downloadArquivo"
                    :parametros="arquivo"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else id="formResposta">
          <rich-text-editor
            style="margin-top: 15px"
            @update-value="atualizarResposta"
            :initial-content="resposta"
            key="tiny-resposta"
          />
          <br />
          <b-row>
            <b-col cols="6">
              <div class="mb-2">
                <span><strong>Anexos *</strong></span>
              </div>
              <b-form-file
                v-model="arquivosResposta"
                placeholder="Selecione..."
                multiple
              ></b-form-file>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <template v-slot:modal-footer="">
        <div class="w-100 d-flex justify-content-between align-items-center">
          <span
            >Válido até
            {{ avisoSelecionado?.DataValidade?.toLocaleDateString() }}
          </span>
          <b-button
            v-if="
              avisoSelecionado.PermiteResposta && respostaSelecionada == null
            "
            size="sm"
            @click="responderAviso()"
          >
            <font-awesome-icon icon="save" class="mr-2" />Enviar Resposta
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="fecharModal()"
          >
            <font-awesome-icon icon="chevron-left" class="mr-2" />Voltar
          </b-button>
        </div>
      </template>
    </b-modal>
    <ModalPdf
      v-if="pdfIndicio"
      titulo="Ver anexo"
      :pdfData="pdfIndicio"
      filename="indicios"
      @fecharModal="pdfIndicio = null"
    />
  </div>
</template>

<script lang="ts">
import messagesService from "@/services/messagesService";
import RichTextEditor from "@/components/RichTextEditor.vue";
import BtnDownload from "@/components/shared/btn-download.vue";
import { UtilsTS } from "@/utilsts";
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Aviso } from "@/types/avisos/aviso";
import { fieldsMuralAvisos } from "@/types/avisos/fields-avisos";
import ModalPdf from "@/components/ModalPdf.vue";
import { store } from "@/store";

const CompProps = Vue.extend({
  name: "consultar-aviso",
  components: {
    BtnDownload,
    ModalPdf,
    RichTextEditor,
  },
});

@Component
export default class ConsultarAviso extends mixins(UtilsTS, CompProps) {
  baixandoAnexo = false;
  avisoSelecionado: Aviso | null = null;
  respostaSelecionada = null;
  resposta = "";
  arquivosResposta: any = [];
  isBusy = true;
  fields = fieldsMuralAvisos;
  items: Aviso[] = [];
  anexosAviso = [];
  pdfIndicio: any = null;

  fecharModal() {
    this.$bvModal.hide("modal-aviso");
    this.baixandoAnexo = false;
    this.anexosAviso = [];
    this.loadData();
  }

  async responderAviso() {
    //validar preenchimento da resposta
    if (!this.resposta || this.resposta.trim() === "") {
      this.$toast.warning("Informe a resposta");
      return;
    }
    if (!this.arquivosResposta || this.arquivosResposta.length < 1) {
      this.$toast.warning("É obrigatório anexar um arquivo à resposta");
      return;
    }

    const response = await messagesService.responderAviso(
      this.resposta,
      this.arquivosResposta,
      this.avisoSelecionado?.Id as number,
    );
    if (response && response.status == 200) {
      this.$toast.success("Aviso respondido com sucesso");
    } else if (response && response.status == 400) {
      this.$toast.error(response.data.msg);
    } else {
      this.$toast.error("Erro inesperado ao responder aviso");
    }
    this.fecharModal();
  }

  async buscarResposta() {
    const response = await messagesService.buscarResposta(
      this.avisoSelecionado?.Id as number,
    );
    if (response && response.status == 200) {
      if (response.data.IdResposta > 0)
        this.respostaSelecionada = response.data;
    } else if (response && response.status == 400) {
      this.$toast.error(response.data.msg);
    } else {
      this.$toast.error("Erro inesperado ao buscar resposta");
    }
  }

  async loadData(): Promise<void> {
    try {
      const response = await messagesService.getAvisosUsuario();
      this.items = response
        .map((r) => {
          r._rowVariant = r.DATA_VISUALIZACAO != null ? "secondary" : "light";
          return r;
        })
        .sort((a, b) => {
          if (a._rowVariant !== b._rowVariant)
            return a._rowVariant === "light" ? -1 : 1;
          if (!a.DataCadastro || !b.DataCadastro) return 0;
          return b.DataCadastro.getTime() - a.DataCadastro.getTime();
        });
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.isBusy = false;
    }
  }

  limparDadosDeAviso() {
    this.avisoSelecionado = null;
    this.respostaSelecionada = null;
    this.resposta = "";
    this.arquivosResposta = null;
  }
  async verAvisoLinha(aviso: Aviso): Promise<void> {
    this.limparDadosDeAviso();
    this.avisoSelecionado = aviso;
    const responseAnexos = await messagesService.getAnexosAviso(
      this.avisoSelecionado?.Id as number,
    );
    this.anexosAviso = responseAnexos.data;
    await this.buscarResposta();
    //inserir Visualizacao
    const response = await messagesService.inserirVisualizacaoAviso(
      this.avisoSelecionado?.Id as number,
      this.avisoSelecionado?.idDestinatario as number,
    );
    if (response && response.status == 200) {
      this.$root.$emit("updateUnreadCount");
      this.$bvModal.show("modal-aviso");
      this.liberarLinks();
    } else {
      this.$toast.error("Erro ao carregar o aviso.");
    }
  }
  async liberarLinks() {
    try {
      store.blockScreen = true;
      await new Promise((r) => setTimeout(r, 1000));
      await this.$nextTick();
      const links = document.querySelectorAll("a.link-protegido");
      links.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          const url = link.getAttribute("href") ?? "no-url";
          const token = localStorage.getItem("token");
          fetch(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }).then(async (response) => {
            this.pdfIndicio = await this.streamToUint8Array(
              response.body as ReadableStream<Uint8Array>,
            );
          });
        });
      });
    } finally {
      store.blockScreen = false;
    }
  }
  async streamToUint8Array(
    stream: ReadableStream<Uint8Array>,
  ): Promise<Uint8Array> {
    const reader = stream.getReader();
    const chunks: Uint8Array[] = [];
    let readResult = await reader.read();
    while (!readResult.done) {
      if (readResult.value) chunks.push(readResult.value);
      readResult = await reader.read();
    }
    // Concatenate all chunks into a single Uint8Array
    let length = chunks.reduce((acc, curr) => acc + curr.length, 0);
    let result = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks) {
      result.set(chunk, offset);
      offset += chunk.length;
    }
    return result;
  }
  async downloadArquivo(arquivo) {
    this.baixandoAnexo = true;
    try {
      const response = await messagesService.baixarAnexo(arquivo.Id);
      if (response && response.status == 200) {
        this.download(arquivo.Nome, response.data);
      } else {
        if (response) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter o arquivo");
      }
    } finally {
      this.baixandoAnexo = false;
    }
  }
  atualizarResposta(value) {
    this.resposta = value;
  }

  mounted() {
    this.loadData();
  }
}
</script>

<style>
.col-actions {
  padding: 0.5 0.15rem !important;
}

.wrapper-icon:hover {
  color: rgb(106, 106, 161);
  cursor: pointer;
}

.actions-icons {
  display: inline-flex;
  font-size: 16px;
  flex-wrap: wrap;
  gap: 18px;
}

.listaAnexos li {
  list-style: none;
}

tr.table-secondary,
tr.table-light {
  cursor: pointer;
}
</style>
